//
// DISCLAIMER
//
// Copyright 2026 ArangoDB GmbH, Cologne, Germany
//

// Notification IDs set by code in deployment-inspector / organization-inspector, with the condition shown in the inventory.
// Keep in sync with internal-apis common/v1/notification_ids.go.
export const builtInNotifications: Record<string, { source_ref: string; condition: string }> = {
  ARANGODB_VERSION_BELOW_MINIMUM: {
    source_ref: "deployment-inspector/NotificationsArangoDBVersionBelowMinimum",
    condition: "ArangoDB version below --notifications-minimum-version (config repo)",
  },
  AZURE_DEPLOYMENT_SHUTDOWN: { source_ref: "deployment-inspector + organization-inspector", condition: "Running on Azure" },
  DEPLOYMENT_READONLY: { source_ref: "deployment-inspector/NotificationsReadOnly", condition: "Deployment in read-only mode" },
  VST_SUPPORT: { source_ref: "deployment-inspector/NotificationsVSTSupportDropped", condition: "VelocyStream connections observed" },
  VST_ORG_SUPPORT_DROPPED: { source_ref: "organization-inspector", condition: "Organization has deployments using VST" },
  DELINQUENT_PAYER: { source_ref: "organization-inspector/hibernate_delinquent_payer", condition: "Unpaid invoices past due" },
  BILLING_V2_MISSING_PAYMENT_METHOD: {
    source_ref: "organization-inspector/notifications/missing_payment_method",
    condition: "Billing V2 organization without a valid Stripe card",
  },
};
